var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { withStyles } from "@material-ui/core";
import * as React from "react";
import { compose, pure, setDisplayName } from "recompose";
import { styles } from "./Form.styles";
export var Render = function (_a) {
    var classes = _a.classes, children = _a.children, props = __rest(_a, ["classes", "children"]);
    return React.createElement("form", __assign({ method: "post", className: classes.root, autoComplete: "off" }, props), children);
};
export function enhance() {
    return compose(withStyles(styles), pure, setDisplayName("Form"));
}
export var Form = enhance()(Render);
